import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const GroupIcon: React.FC<IconProps> = ({
  color = '#fff',
  size = 50,
  className,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    {...rest}
  >
    <path
      d="M3 22C2.44772 22 1.99344 21.55 2.06165 21.002C2.55286 17.0547 5.91969 14 10 14C14.0803 14 17.4471 17.0547 17.9384 21.002C18.0066 21.55 17.5523 22 17 22C16.4477 22 16.0087 21.5489 15.9177 21.0042C15.4434 18.1644 12.9745 16 10 16C7.02554 16 4.55661 18.1644 4.08226 21.0042C3.99127 21.5489 3.55228 22 3 22ZM10 13C6.685 13 4 10.315 4 7C4 3.685 6.685 1 10 1C13.315 1 16 3.685 16 7C16 10.315 13.315 13 10 13ZM10 11C12.21 11 14 9.21 14 7C14 4.79 12.21 3 10 3C7.79 3 6 4.79 6 7C6 9.21 7.79 11 10 11ZM17.873 15.6155C18.0997 15.1117 18.6965 14.8819 19.1679 15.1701C21.1976 16.4114 22.6311 18.5321 22.9384 21.0023C23.0066 21.5503 22.5523 22 22 22C21.4477 22 21.0087 21.549 20.9178 21.0043C20.6403 19.343 19.6802 17.9128 18.3355 17.0118C17.8769 16.7045 17.6465 16.1189 17.873 15.6155ZM17.2886 4.48974C17.4526 3.91586 18.0865 3.60784 18.5807 3.94246C20.0408 4.93106 21 6.603 21 8.5C21 10.9921 19.3446 13.0958 17.0729 13.772C16.5097 13.9397 16 13.4712 16 12.8835V12.8319C16 12.3342 16.3746 11.9266 16.8347 11.7368C18.1059 11.2124 19 9.96109 19 8.5C19 7.41883 18.5104 6.45254 17.7407 5.81064C17.369 5.50067 17.1378 5.01773 17.2707 4.55237L17.2886 4.48974Z"
      fill={color}
    />
  </svg>
)
